module.exports = __webpack_public_path__ + "static/media/pointer-left.9c0ddf56.svg";